import { useMutation } from "@tanstack/react-query";

import {
  type FreedompayPaymentRefundUnreferencedRequestPayload,
  type FreedompayPaymentRefundReferencedRequestPayload
} from "~/types/events";
import { logger } from "~/services/logger";

import { awaitNativeEventOnce } from "../use-native-event-promise/use-native-event-promise";

import { POI_TIMEOUT_MS } from "./constants";

const REFUND_POI_PAYMENT_MUTATION_KEY =
  "freedompay-refund-unreferenced-payment";

export const useRefundPoiPayment = () => {
  return useMutation({
    mutationKey: [REFUND_POI_PAYMENT_MUTATION_KEY],
    mutationFn: async (
      args:
        | FreedompayPaymentRefundUnreferencedRequestPayload
        | FreedompayPaymentRefundReferencedRequestPayload
    ) => {
      if ("transactionReference" in args) {
        return awaitNativeEventOnce({
          timeoutMs: POI_TIMEOUT_MS,
          successEvent: "FREEDOMPAY_PAYMENT_REFUND_REFERENCED_SUCCESS",
          errorEvent: "FREEDOMPAY_PAYMENT_REFUND_REFERENCED_ERROR",
          sendEvent: "FREEDOMPAY_PAYMENT_REFUND_REFERENCED_REQUEST",
          payload: args
        });
      }
      return awaitNativeEventOnce({
        timeoutMs: POI_TIMEOUT_MS,
        successEvent: "FREEDOMPAY_PAYMENT_REFUND_UNREFERENCED_SUCCESS",
        errorEvent: "FREEDOMPAY_PAYMENT_REFUND_UNREFERENCED_ERROR",
        sendEvent: "FREEDOMPAY_PAYMENT_REFUND_UNREFERENCED_REQUEST",
        payload: args
      });
    },
    onError: (error, args) => {
      const isReferenced = "transactionReference" in args;

      logger.warn(
        `[FreedomPay] Error refunding ${
          isReferenced ? "referenced" : "unreferenced"
        } POI payment`,
        {
          err: error,
          order_id: args.orderId,
          payment_id: args.paymentId,
          transaction_reference: isReferenced
            ? args.transactionReference
            : undefined
        }
      );
    }
  });
};
